<user-detail [isUserProfileView]="true" />
